<ng-container *ngIf="roles?.length > 0">
  {{ 'authorization-roles.' + roles.join('/') | translate }}
</ng-container>
